module.exports = __webpack_public_path__ + "static/img/pp_advert.0b1f9042.gif";